import React from "react";
import { TabContent, TabPane } from "reactstrap";
import { SimpleTabContentProp } from "../../../../Types/UiKitsType";
import { Container, Card, Col, Row, CardBody } from "reactstrap";

import { ViewCompanyProfile } from "../../../../Types/CompanyProfile/CompanyProfile";
import DivisionTable from "../../../DataTables/Division/DivisionTable";
import DepartmentTable from "../../../DataTables/Department/DepartmentTable";
import StructureTable from "../../../DataTables/Department/StructureTable";

type CompanyDataProps = {
  companyInfo?: ViewCompanyProfile;
  tabId: string;
};

const PillTabContent: React.FC<CompanyDataProps> = ({ tabId, companyInfo }) => {
  return (
    <TabContent activeTab={tabId}>
      <TabPane tabId={"1"} className={`fade ${tabId === "1" ? "show" : ""}`}>
        <Col sm="12">
          <StructureTable companyInfo={companyInfo} />
        </Col>
      </TabPane>
      <TabPane tabId={"2"} className={`fade ${tabId === "2" ? "show" : ""}`}>
        <Col sm="12">
          <DivisionTable companyInfo={companyInfo} />
        </Col>
      </TabPane>
      <TabPane tabId={"3"} className={`fade ${tabId === "3" ? "show" : ""}`}>
        <Col sm="12">
          <DepartmentTable companyInfo={companyInfo} />
        </Col>
      </TabPane>
    </TabContent>
  );
};
export default PillTabContent;
